import React, { useEffect } from 'react';
import UserUtils from 'utils/user-utils';
import UserAPI from 'api/user';
import { isSearchVehicleInSessionStorage, isOversizedFeatureEnabled, } from 'utils/search-vehicle';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchVehicle } from 'store/search/search-actions';
import { getParkingType } from 'store/selectors/selectors';
const useUserVehicleDefault = () => {
    const isSearchVehicleInitialized = isSearchVehicleInSessionStorage();
    const dispatch = useDispatch();
    const { data: { id: userId, status: userStatus }, } = useSelector((state) => state.user);
    const { vehicle } = useSelector((state) => state.search.data);
    const rootState = useSelector(state => state);
    const parkingType = getParkingType(rootState);
    const isOversizedEnabled = isOversizedFeatureEnabled(parkingType);
    // Set user default vehicle only if:
    // user is logged in and parking type is transient
    // and user has not selected a vehicle
    // so that we don't want to override the user's vehicle selection.
    useEffect(() => {
        if (isOversizedEnabled &&
            userStatus === UserUtils.AUTH_STATE.USER &&
            userId &&
            !vehicle &&
            !isSearchVehicleInitialized) {
            UserAPI.getUserVehicles(userId).then((response) => {
                const defaultVehicleData = response.results.find(v => v.is_default);
                if (defaultVehicleData && defaultVehicleData.info) {
                    const defaultVehicle = {
                        ...defaultVehicleData.info,
                        vehicleProfileId: defaultVehicleData.id,
                        licensePlate: defaultVehicleData.license_plate?.value,
                    };
                    dispatch(setSearchVehicle(defaultVehicle));
                }
            });
        }
    }, [
        userStatus,
        userId,
        dispatch,
        isOversizedEnabled,
        vehicle,
        isSearchVehicleInitialized,
    ]);
};
export function WithUserVehicleDefault(Component) {
    const WithUserVehicleDefaultCompHOC = (props = {}) => {
        useUserVehicleDefault();
        return <Component {...props}/>;
    };
    WithUserVehicleDefaultCompHOC.displayName = `WithUserVehicleDefault(${Component.displayName || Component.name || 'Component'}`;
    return WithUserVehicleDefaultCompHOC;
}
export default useUserVehicleDefault;
